import type { AppState, Profile, SkiDay, Stamp, Trip } from './types'

const KEY = 'passfolio.v1'

const defaultState = (): AppState => ({
  profile: {
    displayName: '',
    passId: 'none',
    seasonLabel: '2025–26',
  },
  stamps: [],
  days: [],
  trips: [],
})

export function loadState(): AppState {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return defaultState()
    const parsed = JSON.parse(raw) as AppState
    return {
      ...defaultState(),
      ...parsed,
      profile: { ...defaultState().profile, ...parsed.profile },
      stamps: parsed.stamps ?? [],
      days: parsed.days ?? [],
      trips: parsed.trips ?? [],
    }
  } catch {
    return defaultState()
  }
}

export function saveState(state: AppState) {
  localStorage.setItem(KEY, JSON.stringify(state))
}

export function uid(prefix = 'id'): string {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36).slice(-4)}`
}

export type { AppState, Profile, Stamp, SkiDay, Trip }
